// import cookie from 'js-cookie'

class Authentication {
	constructor() {
		const xhr = new XMLHttpRequest();
		xhr.onload = () => location.replace(xhr.responseURL);
		xhr.onerror = () => {};

		this.xhr = xhr;
		this.tokens = ['access_token', 'refresh_token'];
		this.baseUrl = '/api/v1';
    
		this.redirectAfterLogin = () => history.pushState(null, '', '/lots');
	}

	relogin() {
		setTimeout(() => {
			window.location.href = `${this.baseUrl}/general/auth?redirect_uri=${window.location.href}`;
		});
	}

	logout() {
		setTimeout(() => {
			window.location.href = `${this.baseUrl}/sso/logout?redirect_uri=${window.location.href}`;
		});
	}
}

export default new Authentication();
